export const companySizeList = [
    {
        id: 1,
        title: "Company (1 to 5 Employees)",
    },
    {
        id: 2,
        title: "Company (6 to 10 Employees)",
    },
    {
        id: 3,
        title: "Company (11 to 20 Employees)",
    },
    {
        id: 4,
        title: "Company (21 to 50 Employees)",
    },
    {
        id: 5,
        title: "Company (51 to 100 Employees)",
    },
    {
        id: 6,
        title: "Company (101 to 500 Employees)",
    },
    {
        id: 7,
        title: "Company (501 to 3500 Employees)",
    },
    {
        id: 8,
        title: "Company (3501 +  Employees)",
    },
    {
        id: 9,
        title: "Recruiting Firm",
    },
    {
        id: 10,
        title: "Staffing Agency",
    },
];

export const employerRoleList = [
    {
        id: 1,
        title: " Business Owner/Leader",
    },
    {
        id: 2,
        title: "Head of Department - HR/Talent",
    },
    {
        id: 3,
        title: "Head of Department - Other",
    },
    {
        id: 4,
        title: "Director - HR/Talent",
    },
    {
        id: 5,
        title: "Director - Other",
    },
    {
        id: 6,
        title: "Manager - HR/Talent",
    },
    {
        id: 7,
        title: "Manager - Other",
    },
    {
        id: 8,
        title: "Social Media Manager",
    },
    {
        id: 9,
        title: "Recruiter/Sourcer",
    },
    {
        id: 10,
        title: "Student/Intern",
    },
    {
        id: 11,
        title: "Job Seeker",
    },
];